export const servicesData = [
         {
           serviceName: "Renewable Energy (Solar)",
           desc:
             "At PO Technology, Renewable Energy isn't just a service—it's a mission. We are dedicated to designing and deploying sustainable energy solutions that harness the power of nature to fuel progress. Through innovative solar, and hybrid systems, we tackle energy challenges head-on, ensuring clean, reliable power for communities and industries.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
               <path
                 d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 0 0 L 32 0 L 32 32 L 0 32 Z"
                 fill="transparent"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Printing",
           desc:
             "From dynamic flyers and crisp business cards to bold large-format visuals, we bring your brand to life—vivid, vibrant, and unforgettable.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
               <path
                 d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 0 0 L 32 0 L 32 32 L 0 32 Z"
                 fill="transparent"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Signage Construction",
           desc:
             "Whether it’s plastic letter fabrication, laser-engraved detail, or dazzling LED frames, our custom signage solutions are built to turn heads and stand the test of time.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
               <path
                 d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 0 0 L 32 0 L 32 32 L 0 32 Z"
                 fill="transparent"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Trainings",
           desc:
             "Through hands-on training in Basic Electronics and Renewable Energy, we equip aspiring professionals with practical skills for the world’s most essential technologies.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
               <path
                 d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 0 0 L 32 0 L 32 32 L 0 32 Z"
                 fill="transparent"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Consulting",
           desc:
             "We provide expert consulting services to individuals, businesses, and organizations seeking smart, energy-efficient, and tech-driven engineering solutions. Our team offers guidance on solar energy systems, electronics integration, automation, and product development, helping clients navigate technical decisions with confidence and clarity.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29">
               <path
                 d="M 27.139 0.885 L 8.779 0.885 C 7.729 0.885 6.877 1.736 6.877 2.785 L 6.877 7.913 L 20.262 7.913 C 22.359 7.913 24.065 9.617 24.065 11.712 L 24.065 16.296 L 27.139 16.296 C 28.19 16.296 29.041 15.446 29.041 14.397 L 29.041 2.785 C 29.041 1.736 28.19 0.885 27.139 0.885 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 20.262 9.812 L 1.902 9.812 C 0.851 9.812 0 10.663 0 11.712 L 0 23.324 C 0 24.373 0.851 25.224 1.902 25.224 L 7.755 25.224 L 9.627 27.447 C 9.988 27.876 10.521 28.124 11.082 28.124 C 11.643 28.124 12.176 27.876 12.537 27.447 L 14.409 25.224 L 20.262 25.224 C 21.312 25.224 22.164 24.373 22.164 23.324 L 22.164 11.712 C 22.164 10.663 21.312 9.812 20.262 9.812 Z M 9.402 20.4 L 4.447 20.4 C 3.922 20.4 3.497 19.975 3.497 19.451 C 3.497 18.926 3.922 18.501 4.447 18.501 L 9.402 18.501 C 9.927 18.501 10.353 18.926 10.353 19.451 C 10.353 19.975 9.927 20.4 9.402 20.4 Z M 17.211 16.472 L 4.447 16.472 C 3.922 16.472 3.497 16.047 3.497 15.523 C 3.497 14.998 3.922 14.573 4.447 14.573 L 17.211 14.573 C 17.736 14.573 18.162 14.998 18.162 15.523 C 18.162 16.047 17.736 16.472 17.211 16.472 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Procurement",
           desc:
             "We streamline the sourcing and procurement of high-quality engineering materials, components, and tools needed for project execution. By leveraging trusted partnerships and technical expertise, we ensure that every item procured meets industry standards and project specifications, thereby reducing risk and enhancing reliability.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
               <path
                 d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
                 fill="rgb(59, 59, 59)"
               ></path>
               <path
                 d="M 0 0 L 32 0 L 32 32 L 0 32 Z"
                 fill="transparent"
               ></path>
             </svg>
           ),
         },

         {
           serviceName: "Maintenance",
           desc:
             "We offer comprehensive maintenance solutions to ensure the long-term performance and reliability of the systems we deploy. From periodic checks to repairs and upgrades, our maintenance services are proactive and responsive, minimizing downtime and extending product life cycles.",
           svgElem: (
             <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
               <path
                 d="M 22.971 11.657 L 22.971 1.6 L 7.886 1.6 L 7.886 16.686 L 16.686 16.686 L 16.686 7.886 L 1.6 7.886 L 1.6 22.971 L 11.657 22.971 M 16.686 28 L 24.229 20.457 M 25.486 16.686 C 24.097 16.686 22.971 17.811 22.971 19.2 C 22.971 20.589 24.097 21.714 25.486 21.714 C 26.874 21.714 28 20.589 28 19.2"
                 fill="transparent"
                 strokeWidth="3"
                 stroke="rgb(59, 59, 59)"
                 strokeMiterlimit="10"
               ></path>
             </svg>
           ),
         },
       ];
